import React from "react";

export const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M3 7.511C2.5401 7.80488 2.16162 8.20984 1.89947 8.68853C1.63732 9.16722 1.49994 9.70423 1.5 10.25V16.25C1.5 19.15 3.85 21.5 6.75 21.5H15.75C16.9 21.5 17.911 20.902 18.489 20H6.75C5.75544 20 4.80161 19.6049 4.09835 18.9017C3.39509 18.1984 3 17.2446 3 16.25V7.511ZM4 8.11V15.75C3.99995 16.5801 4.31755 17.3788 4.88767 17.9822C5.45779 18.5856 6.23719 18.948 7.066 18.995L7.25 19H18.75C19.5801 19.0001 20.3788 18.6824 20.9822 18.1123C21.5856 17.5422 21.948 16.7628 21.995 15.934L22 15.75V8.11L13.35 12.664C13.2421 12.7209 13.122 12.7507 13 12.7507C12.878 12.7507 12.7579 12.7209 12.65 12.664L4 8.11ZM18.75 4H7.25C6.52428 3.99978 5.81937 4.24246 5.24759 4.68938C4.67581 5.13629 4.27006 5.76172 4.095 6.466L13 11.153L21.905 6.466C21.7376 5.79323 21.3595 5.1916 20.8259 4.74901C20.2923 4.30643 19.6311 4.04608 18.939 4.006L18.75 4Z"
        fill="white"
      />
    </svg>
  );
};
